/*
  Mobile-only tap-to-expand for the portrait product card's Quick View +
  Select Your Size (see assets/base.css, the @media (hover: none) block).
  On a hover-capable pointer that block never applies and this script
  exits immediately without attaching a single listener, so desktop is
  physically unaffected by anything here.

  Tapping the product image both activates .is-active (revealing the
  quick-shop bar/size panel and the second image, all keyed off that one
  class in CSS) and prevents the image link's default navigation for
  that first tap — the existing "tap image once to preview, tap again to
  open the product" pattern is preserved: a second tap on an
  already-active card's image is left alone and follows the link
  normally, exactly like tapping any other content inside an active card
  (title, Quick View, size buttons) is left alone.
*/
(function () {
  if (!window.matchMedia || !window.matchMedia("(hover: none)").matches) {
    return;
  }

  var TRANSITION_MS = 360;
  var activeCard = null;

  function resizeSlider(card) {
    var slider = card.closest("[data-flickity-slider]");
    if (!slider || typeof jQuery === "undefined") return;
    var $slider = jQuery(slider);
    if ($slider.data("flickity")) {
      setTimeout(function () {
        $slider.flickity("resize");
      }, TRANSITION_MS);
    }
  }

  function closeActive() {
    if (!activeCard) return;
    activeCard.classList.remove("is-active");
    resizeSlider(activeCard);
    activeCard = null;
  }

  function activate(card) {
    if (activeCard === card) return;
    closeActive();
    card.classList.add("is-active");
    activeCard = card;
    resizeSlider(card);
  }

  document.addEventListener("click", function (event) {
    var imageLink = event.target.closest("[data-main-image]");
    if (imageLink) {
      var card = imageLink.closest("product-card");
      if (card && card.querySelector(".quick-shop-sizes-panel")) {
        if (activeCard !== card) {
          event.preventDefault();
          activate(card);
        }
        return;
      }
    }

    if (activeCard && !activeCard.contains(event.target)) {
      closeActive();
    }
  });
})();
